import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import {
  assertIsASelectItem,
  assertIsNumberAndIsGreaterThanZero,
  type ISelectItem,
} from '~/types/models'

export enum OrderMSServicesStatusIds {
  IN_REVIEW = 1,
  READY_FOR_CONTRACT = 2,
  PREORDER_UNLOCKED = 3,
  PREORDER_LOCKED = 4,
  READY_FOR_SERVICEORDER = 5,
  SERVICEORDER_IN_PROGRESS = 6,
  ACCEPTED = 7,
  COMPLETE = 8,
  ON_HOLD = 9,
  CANCELLED = 10,
}

export function isAnyOpenOrderMSServiceStatus(status: ISelectItem) {
  assertIsASelectItem(isAnyOpenOrderMSServiceStatus.name, status)
  assertIsNumberAndIsGreaterThanZero(status.id)
  return [
    OrderMSServicesStatusIds.IN_REVIEW,
    OrderMSServicesStatusIds.READY_FOR_CONTRACT,
  ].includes(status.id)
}

export function getOrderMSServicesStatii(): ISelectItem[] {
  return [
    {
      id: OrderMSServicesStatusIds.IN_REVIEW,
      label: 'In Review',
      disabled: false,
    },
    {
      id: OrderMSServicesStatusIds.READY_FOR_CONTRACT,
      label: 'Ready for Contract',
      disabled: false,
    },
    {
      id: OrderMSServicesStatusIds.PREORDER_UNLOCKED,
      label: 'Preorder (Unlocked)',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.PREORDER_LOCKED,
      label: 'Preorder (Locked)',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.READY_FOR_SERVICEORDER,
      label: 'Unassigned',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.SERVICEORDER_IN_PROGRESS,
      label: 'ServiceOrder in Progress',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.ACCEPTED,
      label: 'Service Accepted',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.COMPLETE,
      label: 'COMPLETE',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.ON_HOLD,
      label: 'On Hold',
      disabled: true,
    },
    {
      id: OrderMSServicesStatusIds.CANCELLED,
      label: 'Cancelled',
      disabled: true,
    },
  ]
}

export const getOrderMSServiceStatusByLabel = getItemByLabelFactory(
  getOrderMSServicesStatii
)
export const getOrderMSServiceStatusById = getItemByIdFactory(
  getOrderMSServicesStatii
)
